var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-phone-number-input',{ref:"phone-10",attrs:{"default-country-code":_vm.defaultCountryCode,"translations":_vm.translations},on:{"update":_vm.updatePhone},model:{value:(_vm.phoneModel),callback:function ($$v) {_vm.phoneModel=$$v},expression:"phoneModel"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }